// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/font/CentraNo2-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/font/CentraNo2-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/font/CentraNo2-Book.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/img/night starry background.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/img/skillsfooter2.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/************ Custom Font ************/
@font-face {
  font-family: Centra;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-weight: 700;
}
@font-face {
  font-family: Centra;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-weight: 500;
}
@font-face {
  font-family: Centra;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-weight: 400;
}

/************ Default Css ************/
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
  scroll-padding-top: 90px;
  /* verhindert, dass iOS Text beim Drehen automatisch vergroessert */
  -webkit-text-size-adjust: 100%;
}

body {
  font-weight: 400;
  overflow-x: hidden;
  position: relative;
  background-color: #121212 !important;
  color: #fff !important;
  font-family: "Centra", sans-serif !important;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  padding: 0;
  line-height: normal;
  overflow-wrap: break-word;
}

p,
a,
li,
button,
ul {
  margin: 0;
  padding: 0;
  line-height: normal;
  text-decoration: none;
  overflow-wrap: break-word;
}

a:hover {
  text-decoration: none;
}

img {
  width: 100%;
  max-width: 100%;
  height: auto;
}

button {
  border: 0;
  background-color: transparent;
}

input:focus,
textarea:focus,
select:focus {
  outline: none;
}

/* sichtbarer Fokus fuer Tastatur-Navigation */
a:focus-visible,
button:focus-visible {
  outline: 2px solid #2ae0f0;
  outline-offset: 3px;
}

@media (prefers-reduced-motion: reduce) {
  html {
    scroll-behavior: auto;
  }
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}

@media (min-width: 1700px) {
  main .container {
    max-width: 100%;
    padding: 0 150px;
  }
}

p.success {
  color: green;
}

p.danger {
  color: red;
}

/************ Navbar Css ************/
nav.navbar {
  padding: 18px 0;
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 9999;
  transition: 0.32s ease-in-out;
}
nav.navbar.scrolled {
  padding: 0px 0;
  background-color: #0e1320;
}
nav.navbar a.navbar-brand {
  width: auto;
  max-width: 70%;
  display: flex;
  align-items: center;
}
.navbar-brand-inner {
  display: inline-flex;
  align-items: center;
  min-width: 0;
}
.navbar-brand-logo {
  border-radius: 50%;
  width: 50px;
  height: 50px;
  min-width: 50px;
  object-fit: cover;
}
.navbar-brand-name {
  margin: 0;
  padding-left: 20px;
  color: #fff;
  font-weight: 500;
  font-size: 1.4rem;
  white-space: nowrap;
}
nav.navbar .navbar-nav .nav-link.navbar-link {
  font-weight: 400;
  color: #fff !important;
  letter-spacing: 0.8px;
  padding: 0 25px;
  font-size: 18px;
  opacity: 0.75;
}
nav.navbar .navbar-nav a.nav-link.navbar-link:hover,
nav.navbar .navbar-nav a.nav-link.navbar-link.active {
  opacity: 1;
}
span.navbar-text {
  display: flex;
  align-items: center;
}
.social-icon {
  display: inline-flex;
  margin-left: 14px;
}
.social-icon a {
  width: 42px;
  height: 42px;
  min-width: 42px;
  background: rgba(217, 217, 217, 0.1);
  display: inline-flex;
  border-radius: 50%;
  margin-right: 6px;
  align-items: center;
  justify-content: center;
  line-height: 1;
  border: 1px solid rgba(255, 255, 255, 0.5);
  position: relative;
}
.social-icon a::before {
  content: "";
  width: 42px;
  height: 42px;
  position: absolute;
  background-color: #ffffff;
  border-radius: 50%;
  transform: scale(0);
  transition: 0.3s ease-in-out;
}
.social-icon a:hover::before {
  transform: scale(1);
}
.social-icon a img {
  width: 40%;
  z-index: 1;
  transition: 0.3s ease-in-out;
}
.social-icon a:hover img {
  filter: brightness(0) saturate(100%) invert(0%) sepia(7%) saturate(98%)
    hue-rotate(346deg) brightness(95%) contrast(86%);
}
.navbar-text button {
  font-weight: 700;
  color: #fff;
  border: 1px solid #fff;
  padding: 18px 34px;
  font-size: 18px;
  margin-left: 18px;
  position: relative;
  background-color: transparent;
  transition: 0.3s ease-in-out;
}
.navbar-text button span {
  z-index: 1;
}
.navbar-text button::before {
  content: "";
  width: 0%;
  height: 100%;
  position: absolute;
  background-color: #fff;
  left: 0;
  top: 0;
  z-index: -1;
  transition: 0.3s ease-in-out;
}
.navbar-text button:hover {
  color: #121212;
}
.navbar-text button:hover::before {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
}
nav.navbar .navbar-toggler {
  padding: 8px 10px;
}
nav.navbar .navbar-toggler:active,
nav.navbar .navbar-toggler:focus {
  outline: none;
  box-shadow: none;
}
nav.navbar .navbar-toggler-icon {
  width: 24px;
  height: 17px;
  background-image: none;
  position: relative;
  border-bottom: 2px solid #fff;
  transition: all 300ms linear;
  top: -2px;
}
nav.navbar .navbar-toggler-icon:focus {
  border-bottom: 2px solid #fff;
}
nav.navbar .navbar-toggler-icon:after,
nav.navbar .navbar-toggler-icon:before {
  width: 24px;
  position: absolute;
  height: 2px;
  background-color: #fff;
  top: 0;
  left: 0;
  content: "";
  z-index: 2;
  transition: all 300ms linear;
}
nav.navbar .navbar-toggler-icon:after {
  top: 8px;
}
nav.navbar .navbar-toggler[aria-expanded="true"] .navbar-toggler-icon:after {
  transform: rotate(45deg);
  background-color: #fff;
  height: 2px;
}
nav.navbar .navbar-toggler[aria-expanded="true"] .navbar-toggler-icon:before {
  transform: translateY(8px) rotate(-45deg);
  background-color: #fff;
  height: 2px;
}
nav.navbar .navbar-toggler[aria-expanded="true"] .navbar-toggler-icon {
  border-color: transparent;
}

/* --- Navbar responsive --- */
@media (max-width: 1199.98px) {
  nav.navbar .navbar-nav .nav-link.navbar-link {
    padding: 0 14px;
    font-size: 17px;
  }
}

@media (max-width: 991.98px) {
  .navbar-brand-name {
    font-size: 1.15rem;
  }
  .navbar-brand-logo {
    width: 42px;
    height: 42px;
    min-width: 42px;
  }
}

/* aufgeklapptes Menue braucht einen eigenen Hintergrund,
   weil die Navbar ueber dem Banner transparent ist
   (Breakpoint passt zu expand="lg" in der NavBar) */
@media (max-width: 991.98px) {
  nav.navbar {
    padding: 10px 0;
  }
  nav.navbar .navbar-collapse {
    background-color: rgba(14, 19, 32, 0.97);
    border-radius: 14px;
    margin-top: 12px;
    padding: 16px 18px;
    max-height: calc(100vh - 120px);
    overflow-y: auto;
  }
  nav.navbar .navbar-nav .nav-link.navbar-link {
    padding: 12px 0;
    font-size: 18px;
  }
  span.navbar-text {
    justify-content: center;
    margin-top: 10px;
  }
  .social-icon {
    margin-left: 0;
  }
  .navbar-brand-name {
    padding-left: 12px;
  }
}

@media (max-width: 359.98px) {
  .navbar-brand-name {
    display: none;
  }
}

/************ Banner Css ************/
.banner {
  margin-top: 0;
  padding: clamp(120px, 16vw, 190px) 0 clamp(70px, 12vw, 170px) 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-position: top center;
  background-size: cover;
  background-repeat: no-repeat;
}
.banner-row {
  display: flex;
  align-items: center;
  margin-left: 0;
}
.banner .tagline {
  font-weight: 700;
  letter-spacing: 0.8px;
  padding: 8px 10px;
  background: linear-gradient(
    90.21deg,
    rgba(78, 224, 253, 0.5) -5.91%,
    rgba(16, 19, 199, 0.5) 111.58%
  );
  border: 1px solid rgba(255, 255, 255, 0.5);
  font-size: clamp(15px, 2.2vw, 20px);
  margin-bottom: 16px;
  display: inline-block;
}
.banner h1 {
  font-size: clamp(2.1rem, 6vw, 65px);
  font-weight: 700;
  letter-spacing: 0.8px;
  line-height: 1.05;
  margin-bottom: 20px;
  display: block;
}
.banner p {
  color: #b8b8b8;
  font-size: clamp(16px, 2vw, 20px);
  letter-spacing: 0.8px;
  line-height: 1.6em;
  width: 100%;
  text-align: justify;
  hyphens: auto;
  max-width: 62ch;
}
.banner button {
  color: #fff;
  font-weight: 700;
  font-size: 20px;
  margin-top: 60px;
  letter-spacing: 0.8px;
  display: flex;
  align-items: center;
}
.banner button svg {
  font-size: 25px;
  margin-left: 10px;
  transition: 0.3s ease-in-out;
  line-height: 1;
}
.banner button:hover svg {
  margin-left: 25px;
}
.banner-text {
  margin-top: 40px;
}
.banner-image-col {
  display: flex;
  justify-content: center;
  margin-top: 50px;
}
.banner-image {
  border: 4px solid #fff;
  border-radius: 50%;
  width: clamp(190px, 40vw, 300px);
  height: clamp(190px, 40vw, 300px);
  object-fit: cover;
  margin-bottom: 30px;
}

@media (max-width: 767.98px) {
  .banner {
    text-align: center;
  }
  .banner p {
    margin: 0 auto;
  }
  /* die harten Zeilenumbrueche im Text stoeren auf schmalen Displays */
  .banner p br {
    display: none;
  }
  .banner-text {
    margin-top: 0;
  }
  .banner-image-col {
    margin-top: 40px;
    order: -1;
  }
}

@keyframes updown {
  0% {
    transform: translateY(-20px);
  }
  50% {
    transform: translateY(20px);
  }
  100% {
    transform: translateY(-20px);
  }
}
.txt-rotate > .wrap {
  border-right: 0.08em solid #666;
}

/************ Skills Css ************/
.skill {
  padding: 0 0 50px 0;
  position: relative;
}

.skill-bx {
  background: #19233f;
  border-radius: clamp(24px, 5vw, 64px);
  text-align: center;
  padding: clamp(32px, 5vw, 60px) clamp(18px, 4vw, 50px);
  margin-top: -60px;
}
.skill h2 {
  font-size: clamp(1.9rem, 5vw, 45px);
  font-weight: 700;
}
.skill p {
  color: #b8b8b8;
  font-size: clamp(15px, 2vw, 18px);
  letter-spacing: 0.8px;
  line-height: 1.5em;
  margin: 14px auto clamp(35px, 6vw, 75px) auto;
  max-width: 70ch;
}
.skill-slider {
  width: 80%;
  margin: 0 auto;
  position: relative;
}
.skill-slider .item {
  padding: 0 10px;
}
.skill-slider .item img {
  /* einheitliche Icon-Hoehe, damit die Labels auf einer Linie stehen */
  height: clamp(56px, 9vw, 90px);
  width: auto;
  max-width: 100%;
  object-fit: contain;
  margin: 0 auto 15px auto;
  display: block;
}

.slide-img {
  height: 50px;
  width: 50px;
}

.background-image-left {
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  position: absolute;
  bottom: 0;
  background-color: #0e1320;
  height: 100%;
  z-index: -4;
}

@media (max-width: 991.98px) {
  .skill-slider {
    width: 92%;
  }
}

@media (max-width: 575.98px) {
  .skill-bx {
    margin-top: -30px;
  }
  .skill-slider {
    width: 100%;
  }
  /* harte Umbrueche im Fliesstext deaktivieren */
  .skill p br {
    display: none;
  }
}

/************ Projects Css ************/
.project {
  padding: clamp(60px, 9vw, 100px) 0;
  position: relative;
  background-color: #0e1320;
}
.project h2 {
  font-size: clamp(1.9rem, 5vw, 45px);
  font-weight: 700;
  text-align: center;
}
.project p {
  color: #b8b8b8;
  font-size: clamp(15px, 2vw, 18px);
  letter-spacing: 0.8px;
  line-height: 1.5em;
  margin: 14px auto 30px auto;
  text-align: justify;
  width: 100%;
  hyphens: auto;
  max-width: 70ch;
}
.project .nav.nav-pills {
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
  border-radius: 50px;
  background-color: rgba(255, 255, 255, 0.1);
  overflow: hidden;
}
.project .nav.nav-pills .nav-item {
  width: 33.33333%;
}
.project .nav.nav-pills .nav-link {
  background-color: transparent;
  border-radius: 0;
  padding: 17px 8px;
  color: #fff;
  width: 100%;
  font-size: clamp(14px, 1.6vw, 17px);
  letter-spacing: 0.8px;
  font-weight: 500;
  position: relative;
  transition: 0.3s ease-in-out;
  text-align: center;
  z-index: 0;
}
.project .nav.nav-pills .nav-link::before {
  content: "";
  position: absolute;
  width: 0;
  height: 100%;
  background: linear-gradient(
    90.21deg,
    #2ae0f0 -5.91%,
    rgba(16, 19, 199, 0.5) 111.58%
  );
  top: 0;
  left: 0;
  z-index: -1;
  transition: 0.3s ease-in-out;
}
.project .nav.nav-pills .nav-link.active::before {
  width: 100% !important;
}
.project .nav.nav-pills .nav-link.active {
  border: 1px solid rgba(255, 255, 255, 1);
}
.nav-link#projects-tabs-tab-first {
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 55px 0px 0px 55px;
}
.nav-link#projects-tabs-tab-second {
  border-top: 1px solid rgba(255, 255, 255, 0.5);
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
}
.nav-link#projects-tabs-tab-third {
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 0 55px 55px 0;
}

/* Tabs untereinander, sobald drei Pills nebeneinander zu eng werden */
@media (max-width: 575.98px) {
  .project .nav.nav-pills {
    flex-direction: column;
    border-radius: 22px;
  }
  .project .nav.nav-pills .nav-item {
    width: 100%;
  }
  .project .nav.nav-pills .nav-link {
    padding: 14px 8px;
  }
  .nav-link#projects-tabs-tab-first {
    border-radius: 22px 22px 0 0;
  }
  .nav-link#projects-tabs-tab-second {
    border-left: 1px solid rgba(255, 255, 255, 0.5);
    border-right: 1px solid rgba(255, 255, 255, 0.5);
  }
  .nav-link#projects-tabs-tab-third {
    border-radius: 0 0 22px 22px;
  }
}

.projects-grid {
  max-width: 75%;
  width: 100%;
}

@media (max-width: 1199.98px) {
  .projects-grid {
    max-width: 90%;
  }
}

@media (max-width: 767.98px) {
  .projects-grid {
    max-width: 100%;
  }
}

.proj-imgbx {
  position: relative;
  border-radius: 30px;
  overflow: hidden;
  margin-bottom: 24px;
}
.proj-imgbx::before {
  content: "";
  background: linear-gradient(90.21deg, #117087 -5.91%, #09205a 111.58%);
  opacity: 0.85;
  position: absolute;
  width: 100%;
  height: 0;
  transition: 0.4s ease-in-out;
}
.proj-imgbx:hover::before {
  height: 100%;
}
.proj-txtx {
  position: absolute;
  top: 65%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: 0.5s ease-in-out;
  opacity: 0;
  width: 100%;
  padding: 0 14px;
}
.proj-imgbx:hover .proj-txtx {
  top: 50%;
  opacity: 1;
}
.proj-txtx h4,
.proj-txtx h5 {
  font-size: clamp(15px, 2.4vw, 18px);
  font-weight: 700;
  text-align: center;
  letter-spacing: 0.8px;
  line-height: 1.15em;
  margin-bottom: 6px;
}
.proj-txtx span {
  font-weight: 400;
  font-size: clamp(12px, 1.4vw, 12px);
  hyphens: auto;
  text-align: justify;
}

/* Tastaturfokus oeffnet das Overlay wie ein Hover */
.proj-imgbx:focus-within::before {
  height: 100%;
}
.proj-imgbx:focus-within .proj-txtx {
  top: 50%;
  opacity: 1;
}

.proj-caption {
  display: none;
}

.proj-tech-text {
  font-weight: 600 !important;
  font-style: normal !important;
  text-align: center !important;
}

@media (hover: none) {
  .proj-imgbx::before,
  .proj-txtx {
    display: none;
  }
  .proj-imgbx {
    margin-bottom: 14px;
  }
  .proj-caption {
    display: block;
    margin-bottom: 40px;
    text-align: left;
    color: #fff;
  }
  .proj-caption h5 {
    font-size: clamp(17px, 4.2vw, 20px);
    font-weight: 700;
    text-align: center;
    letter-spacing: 0.8px;
    line-height: 1.25;
    margin-bottom: 8px;
  }
  .proj-caption p {
    font-size: clamp(14px, 3.6vw, 16px);
    line-height: 1.55;
    color: #b8b8b8;
    margin-bottom: 0 0 8px 0;
    text-align: justify;
    hyphens: auto;
  }
  .proj-caption .proj-caption-tech {
    display: block;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.5px;
    color: #2ae0f0;
  }
}

.background-image-right {
  top: 20%;
  position: absolute;
  bottom: 0;
  width: 35%;
  right: 0;
  z-index: -4;
}

.project-teaser {
  padding: clamp(14px, 3vw, 20px);
  border-radius: 6px;
  background-color: white;
  color: black;
}

.project-content {
  display: flex;
  align-items: center;
  gap: 30px;
  flex-wrap: wrap;
}

.project-text {
  flex: 1 1 320px;
  min-width: min(300px, 100%);
  text-align: left;
}

.project-text p,
.project-text li {
  font-size: clamp(15px, 1.8vw, 17px);
}

.project-logo {
  max-width: 200px;
  width: 100%;
  margin-bottom: 10px;
}

.project-logo-rounded {
  max-width: 65px;
  width: 65px;
  margin-bottom: 10px;
  border-radius: 50%;
}

.project-highlights {
  margin-top: 20px;
  margin-left: 30px;
  color: rgba(83, 83, 83, 0.75);
}

.project-highlights-title {
  text-align: left !important;
  margin-bottom: 10px !important;
  color: #3a3a3a !important;
  text-decoration: underline;
}

.project-techstack {
  border: 2px solid gray;
  border-radius: 6px;
  padding: 10px;
  margin-top: 40px;
}

.project-image-wrapper {
  flex: 1 1 320px;
  min-width: min(300px, 100%);
  display: flex;
  justify-content: center;
  align-items: center;
}

.project-screenshot {
  width: 100%;
  max-width: 400px;
  height: auto;
  border-radius: 10px;
  transition: all 0.3s ease-in-out;
  box-shadow: 0 4px 15px rgba(22, 22, 22, 0.2);
}

.image-link {
  display: block;
  width: 100%;
  max-width: 400px;
}

.github-link {
  display: inline-block;
  margin-top: 15px;
  padding: 10px 20px;
  background-color: #333;
  color: #fff;
  text-decoration: none;
  border-radius: 5px;
  font-weight: bold;
}

.project-button-finecheck {
  text-align: left;
  margin-top: 20px;
}

.github-link:hover {
  background-color: #555;
}

@media (max-width: 991.98px) {
  .project-highlights {
    margin-left: 18px;
  }
}

@media (max-width: 768px) {
  .project-content {
    flex-direction: column;
    align-items: center;
  }

  .project-text,
  .project-image-wrapper {
    flex: 1 1 100%;
    text-align: left;
  }

  .project-text h2 {
    text-align: center;
  }

  .project-button-finecheck {
    text-align: center;
  }
}

@media (max-width: 575.98px) {
  .project-highlights {
    margin-left: 6px;
  }
  .project-highlights ul {
    padding-left: 18px;
  }
  .project-techstack {
    margin-top: 24px;
  }
}

.image-link:hover .project-screenshot {
  transform: scale(1.05);
  transition: all 0.3s ease-in-out;
}

/************ About Css ************/

.about {
  background-color: #0e1320;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-around;
  align-items: center;
}

.about p {
  font-size: clamp(1rem, 2.2vw, 1.3rem);
}

.about h1 {
  margin-bottom: clamp(28px, 5vw, 50px);
  font-size: clamp(1.9rem, 5vw, 45px);
  font-weight: 700;
  text-align: center;
}

.about img {
  width: 100%;
  max-width: 100%;
  height: auto;
  border-radius: 10px;
}

.about-text {
  margin-right: 20px;
}

.about-headline {
  color: #6faf61;
  font-size: clamp(1.1rem, 2.6vw, 1.5rem);
}

.about-headline span {
  color: #2bbbd4;
  font-size: clamp(1.5rem, 5vw, 2.8rem);
}

.about-body {
  line-height: 1.6;
  margin-top: 30px;
  text-align: justify;
  hyphens: auto;
  margin-bottom: 50px;
}

.about-highlight {
  color: #2bbbd4;
}

.about-quote {
  border: 2px solid #fff;
  padding: 15px 10px 15px 15px;
  border-radius: 6px;
  margin-top: 30px;
}

.about-image-col {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.about-image-frame {
  border: 4px solid #fff;
  border-radius: 14px;
  display: inline-block;
  width: 80%;
  overflow: hidden;
}

@media (max-width: 991.98px) {
  .about-text {
    margin-right: 0;
  }
  .about-image-col {
    justify-content: center;
    margin-top: 30px;
  }
  .about-image-frame {
    width: min(420px, 100%);
  }
  .about-body {
    margin-bottom: 30px;
  }
}

.about-me-btn {
  font-weight: 700;
  color: black;
  border: 1px solid #fff;
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 18px;
  text-decoration: none;
  background-color: white;
  position: relative;
  transition: 0.3s ease-in-out;
  text-transform: uppercase;
}

.about-me-btn:hover {
  color: white;
  background-color: #2ea3b7;
  border-color: #2ea3b7;
}

/************ Timeline Css ************/

.timeline {
  position: relative;
}

.timeline-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 clamp(12px, 4vw, 24px);
}

.timeline-headline h2 {
  padding-top: clamp(60px, 9vw, 100px);
  padding-bottom: clamp(30px, 5vw, 50px);
  display: block;
  font-size: clamp(1.9rem, 5vw, 45px);
  text-align: center;
}

.background-image {
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  position: absolute;
  bottom: 0;
  background-color: #0e1320;
  height: 100%;
  z-index: -10;
  opacity: 70%;
}

.process-wrapper {
  margin: auto;
  max-width: 1080px;
  width: 100%;
}

/* --- Fortschrittsleiste --- */
.progress-track {
  position: relative;
  width: 100%;
  margin: 0 auto clamp(40px, 6vw, 70px) auto;
  padding-top: 20px;
}

.progress-line {
  position: absolute;
  left: 12.5%;
  right: 12.5%;
  top: 46px;
  height: 6px;
  background: #eee;
  border-radius: 50px;
  z-index: 1;
}

.progress-line-fill {
  width: var(--progress, 0%);
  height: 100%;
  background: #207893;
  background: linear-gradient(to right, #207893 0%, #2ea3b7 100%);
  border-radius: 50px;
  transition: width 0.9s ease;
}

.progress-steps {
  display: flex;
  flex-direction: row;
  position: relative;
  z-index: 2;
}

.progress-step {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 26px;
  text-align: center;
  padding: 0 8px;
  color: #fff;
  background: transparent;
  border: 0;
  cursor: pointer;
  font-size: clamp(13px, 1.4vw, 16px);
  line-height: 1.3;
  transition: color 0.3s ease-in-out;
}

.progress-step:hover,
.progress-step.active {
  color: rgba(78, 224, 253, 0.9);
}

.progress-step-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 52px;
  width: 52px;
  transition: transform 0.3s ease-in-out;
}

.progress-step:hover .progress-step-icon {
  transform: scale(1.12);
}

.progress-step-icon img {
  width: auto;
  max-width: 46px;
  max-height: 46px;
  background-color: white;
  object-fit: contain;
}

/* Mobile: Zeitstrahl wird zur vertikalen Liste */
@media (max-width: 767.98px) {
  .progress-line {
    display: none;
  }
  .progress-steps {
    flex-direction: column;
    gap: 4px;
    border-left: 3px solid rgba(255, 255, 255, 0.18);
    padding-left: 4px;
  }
  .progress-step {
    flex-direction: row;
    align-items: center;
    gap: 14px;
    text-align: left;
    padding: 12px 10px;
    border-left: 3px solid transparent;
    margin-left: -5px;
    font-size: 15px;
  }
  .progress-step.active {
    border-left-color: #2ea3b7;
    background: rgba(46, 163, 183, 0.12);
    border-radius: 0 8px 8px 0;
  }
  .progress-step-icon {
    height: 40px;
    width: 40px;
    min-width: 40px;
  }
  .progress-step-icon img {
    max-width: 45px !important;
    max-height: 34px;
  }
  .progress-track {
    padding-top: 0;
  }
}

/* --- Inhalte der Zeitstrahl-Abschnitte --- */
.progress-content-bulletpoint {
  font-size: 1.7rem;
  line-height: 1;
}

#progress-content-section {
  width: 100%;
  margin: auto;
  background: #19233f;
  border-radius: 8px;
}

#progress-content-section .section-content {
  padding: clamp(18px, 4vw, 30px) clamp(14px, 4vw, 40px);
  text-align: center;
  animation: FadeInUp 700ms ease 1;
  animation-fill-mode: forwards;
  transform: translateY(15px);
  opacity: 0;
  margin-bottom: clamp(60px, 10vw, 200px);
}

#progress-content-section .section-content h2 {
  font-size: clamp(18px, 2.6vw, 22px);
  text-transform: uppercase;
  color: white;
  text-align: center;
  letter-spacing: 1px;
}

#progress-content-section .section-content h5 {
  text-transform: uppercase;
  color: white;
  text-align: center;
  letter-spacing: 1px;
  font-size: clamp(15px, 2vw, 20px);
}

#progress-content-section .section-content p,
#progress-content-section .section-content span,
#progress-content-section .section-content li {
  font-size: clamp(15px, 1.9vw, 20px);
  line-height: 1.7em;
  color: white;
}

.timeline-lead {
  margin-bottom: 15px;
}

.timeline-task-box {
  border: 2px solid rgb(198 222 227 / 64%);
  padding: clamp(10px, 2.5vw, 16px);
  background-color: #76becd29;
  border-radius: 6px;
  width: min(90%, 100%);
  margin: 20px auto 0 auto;
}

.timeline-tasks {
  display: flex;
  flex-direction: column;
  gap: 10px;
  text-align: left;
  margin: 0 auto;
  padding-left: clamp(0px, 3vw, 40px);
  max-width: 80ch;
}

.timeline-tasks > span,
.timeline-tasks > p {
  color: #fff;
  margin: 0;
}

@media (max-width: 575.98px) {
  .timeline-task-box {
    width: 100%;
  }
  .timeline-tasks {
    padding-left: 0;
  }
  .progress-content-bulletpoint {
    font-size: 1.2rem;
  }
  /* harte Umbrueche in langen Textbloecken deaktivieren */
  #progress-content-section .section-content br {
    display: none;
  }
}

@keyframes FadeInUp {
  0% {
    transform: translateY(15px);
    opacity: 0;
  }

  100% {
    transform: translateY(0px);
    opacity: 1;
  }
}

/************ Contact Css ************/
.contact {
  background: linear-gradient(90.21deg, #117087 -5.91%, #161159 111.58%);
  padding: 60px 0 clamp(80px, 14vw, 200px) 0;
}
.contact img {
  width: 92%;
}
.contact h2 {
  font-size: clamp(1.9rem, 5vw, 45px);
  font-weight: 700;
  margin-bottom: 30px;
}
.contact form input,
.contact form textarea {
  width: 100%;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 20px;
  color: #fff;
  margin: 0 0 8px 0;
  padding: 18px 26px;
  font-weight: 500;
  font-size: 16px;
  letter-spacing: 0.8px;
  transition: 0.3s ease-in-out;
}
.contact form input:focus,
.contact form textarea:focus {
  background: rgba(255, 255, 255, 1);
  color: #121212;
}
.contact form input::placeholder,
.contact form textarea::placeholder {
  font-size: 16px;
  font-weight: 400;
  color: #fff;
}
.contact form input:focus::placeholder,
.contact form textarea:focus::placeholder {
  color: #121212;
  opacity: 0.8;
}
.contact form button {
  font-weight: 700;
  color: #000;
  background-color: #fff;
  padding: 14px 48px;
  font-size: 18px;
  margin-top: 25px;
  border-radius: 0;
  position: relative;
  transition: 0.3s ease-in-out;
}
.contact form button span {
  z-index: 1;
  position: relative;
}
.contact form button:hover {
  color: #fff;
}
.contact form button::before {
  content: "";
  background: #121212;
  width: 0;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  transition: 0.3s ease-in-out;
}
.contact form button:hover::before {
  width: 100%;
}

/************ Footer Css ************/
.footer {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  padding: 30px 0;
}
.footer-logo-col {
  display: flex;
  align-items: center;
}
.footer-logo {
  border-radius: 50%;
  width: clamp(100px, 22vw, 150px);
  height: auto;
}
.footer-meta-col {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
}
.newsletter-bx {
  background: #ffffff;
  border-radius: clamp(24px, 5vw, 55px);
  color: #121212;
  padding: clamp(35px, 8vw, 85px) clamp(20px, 8vw, 125px);
  margin-bottom: clamp(40px, 7vw, 80px);
  margin-top: -122px;
}
.newsletter-bx h3 {
  font-weight: 700;
  letter-spacing: 0.5px;
  line-height: 1.2em;
}
.new-email-bx {
  background: #fff;
  padding: 5px;
  border-radius: 20px;
  position: relative;
  z-index: 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.new-email-bx::before {
  content: "";
  background: linear-gradient(90.21deg, #40a8c7 -5.91%, #161159 111.58%);
  border-radius: 20px;
  position: absolute;
  z-index: -1;
  top: -1px;
  left: -1px;
  bottom: -1px;
  right: -1px;
}
.new-email-bx::after {
  content: "";
  background: #fff;
  border-radius: 20px;
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
.new-email-bx input {
  width: 100%;
  color: #121212;
  font-weight: 500;
  background: transparent;
  border: 0;
  padding: 0 15px;
}
.new-email-bx button {
  background: linear-gradient(90.21deg, #45b7d9 -5.91%, #181167 111.58%);
  padding: 20px 65px;
  color: #fff;
  font-weight: 500;
  letter-spacing: 0.5px;
  border-radius: 18px;
}
.footer img {
  width: 26%;
}
.footer .footer-logo {
  width: clamp(100px, 22vw, 150px);
}
.footer .social-icon a img {
  width: 40%;
}
.footer p {
  font-weight: 400;
  font-size: 14px;
  color: #b8b8b8;
  letter-spacing: 0.5px;
  margin-top: 20px;
}

@media (max-width: 575.98px) {
  .footer-logo-col {
    justify-content: center;
  }
  .footer-meta-col {
    align-items: center;
    margin-top: 20px;
  }
  .footer p {
    text-align: center;
  }
}

.react-multiple-carousel__arrow--right {
  right: calc(1% + 1px) !important;
}

.react-multiple-carousel__arrow--left {
  left: calc(2% + 1px) !important;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,mBAAmB;EACnB,4CAA4C;EAC5C,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,4CAA8C;EAC9C,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,mEAAmE;EACnE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,oCAAoC;EACpC,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;;;;;;EAME,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;;;;EAKE,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,SAAS;EACT,6BAA6B;AAC/B;;AAEA;;;EAGE,aAAa;AACf;;AAEA,8CAA8C;AAC9C;;EAEE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE;IACE,qBAAqB;EACvB;EACA;;;IAGE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;EACxC;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA,qCAAqC;AACrC;EACE,eAAe;EACf,eAAe;EACf,WAAW;EACX,MAAM;EACN,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,aAAa;AACf;AACA;;EAEE,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,oCAAoC;EACpC,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,0CAA0C;EAC1C,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;AAC9B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,UAAU;EACV,4BAA4B;AAC9B;AACA;EACE;oDACkD;AACpD;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;EACX,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,OAAO;EACP,MAAM;EACN,WAAW;EACX,4BAA4B;AAC9B;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,6BAA6B;EAC7B,4BAA4B;EAC5B,SAAS;AACX;AACA;EACE,6BAA6B;AAC/B;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,MAAM;EACN,OAAO;EACP,WAAW;EACX,UAAU;EACV,4BAA4B;AAC9B;AACA;EACE,QAAQ;AACV;AACA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,yCAAyC;EACzC,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;EACE;IACE,eAAe;IACf,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;;oDAEoD;AACpD;EACE;IACE,eAAe;EACjB;EACA;IACE,wCAAwC;IACxC,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,+BAA+B;IAC/B,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,eAAe;EACjB;EACA;IACE,uBAAuB;IACvB,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,+DAA+D;EAC/D,yDAAmE;EACnE,+BAA+B;EAC/B,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB;;;;GAIC;EACD,0CAA0C;EAC1C,mCAAmC;EACnC,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,cAAc;EACd,iCAAiC;EACjC,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gCAAgC;EAChC,iCAAiC;EACjC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;EACA,qEAAqE;EACrE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,SAAS;EACX;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;AACA;EACE,+BAA+B;AACjC;;AAEA,qCAAqC;AACrC;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,kBAAkB;EAClB,sDAAsD;EACtD,iBAAiB;AACnB;AACA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,iCAAiC;EACjC,qBAAqB;EACrB,kBAAkB;EAClB,6CAA6C;EAC7C,eAAe;AACjB;AACA;EACE,UAAU;EACV,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,qEAAqE;EACrE,8BAA8B;EAC9B,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;EAClB,SAAS;EACT,yBAAyB;EACzB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;EACA,+CAA+C;EAC/C;IACE,aAAa;EACf;AACF;;AAEA,uCAAuC;AACvC;EACE,kCAAkC;EAClC,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,iCAAiC;EACjC,qBAAqB;EACrB,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,eAAe;AACjB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,WAAW;EACX,mCAAmC;EACnC,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ;;;;GAIC;EACD,MAAM;EACN,OAAO;EACP,WAAW;EACX,4BAA4B;AAC9B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,0CAA0C;EAC1C,gCAAgC;AAClC;AACA;EACE,8CAA8C;EAC9C,iDAAiD;AACnD;AACA;EACE,0CAA0C;EAC1C,4BAA4B;AAC9B;;AAEA,sEAAsE;AACtE;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,+CAA+C;IAC/C,gDAAgD;EAClD;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,sEAAsE;EACtE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,4BAA4B;AAC9B;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,4BAA4B;EAC5B,UAAU;EACV,WAAW;EACX,eAAe;AACjB;AACA;EACE,QAAQ;EACR,UAAU;AACZ;AACA;;EAEE,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,aAAa;EACb,mBAAmB;AACrB;;AAEA,oDAAoD;AACpD;EACE,YAAY;AACd;AACA;EACE,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE;;IAEE,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,mCAAmC;IACnC,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,mCAAmC;IACnC,iBAAiB;IACjB,cAAc;IACd,wBAAwB;IACxB,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;EAChB;AACF;;AAEA;EACE,QAAQ;EACR,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,gCAAgC;EAChC,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;;IAEE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA,oCAAoC;;AAEpC;EACE,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,uBAAuB;IACvB,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,uCAAuC;;AAEvC;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,cAAc;EACd,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;EAClB,SAAS;EACT,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,WAAW;EACX,0CAA0C;EAC1C,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,mBAAmB;EACnB,+DAA+D;EAC/D,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,SAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,mCAAmC;EACnC,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,iDAAiD;AACjD;EACE;IACE,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,QAAQ;IACR,gDAAgD;IAChD,iBAAiB;EACnB;EACA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,kCAAkC;IAClC,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,0BAA0B;IAC1B,oCAAoC;IACpC,0BAA0B;EAC5B;EACA;IACE,YAAY;IACZ,WAAW;IACX,eAAe;EACjB;EACA;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;AACF;;AAEA,8CAA8C;AAC9C;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sDAAsD;EACtD,kBAAkB;EAClB,gCAAgC;EAChC,6BAA6B;EAC7B,2BAA2B;EAC3B,UAAU;EACV,uCAAuC;AACzC;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;;;EAGE,mCAAmC;EACnC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,iCAAiC;EACjC,2BAA2B;EAC3B,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,mCAAmC;EACnC,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,SAAS;AACX;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA,wDAAwD;EACxD;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE,0BAA0B;IAC1B,UAAU;EACZ;AACF;;AAEA,sCAAsC;AACtC;EACE,sEAAsE;EACtE,0CAA0C;AAC5C;AACA;EACE,UAAU;AACZ;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;EAEE,WAAW;EACX,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,4BAA4B;AAC9B;AACA;;EAEE,kCAAkC;EAClC,cAAc;AAChB;AACA;;EAEE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;;EAEE,cAAc;EACd,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;AAC9B;AACA;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,4BAA4B;AAC9B;AACA;EACE,WAAW;AACb;;AAEA,qCAAqC;AACrC;EACE,yDAAuD;EACvD,kCAAkC;EAClC,sBAAsB;EACtB,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;EACd,uDAAuD;EACvD,qCAAqC;EACrC,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,WAAW;EACX,sEAAsE;EACtE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;EACV,YAAY;EACZ,WAAW;AACb;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;AACV;AACA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;AACA;EACE,sEAAsE;EACtE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,gCAAgC;AAClC;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC","sourcesContent":["/************ Custom Font ************/\n@font-face {\n  font-family: Centra;\n  src: url(\"./assets/font/CentraNo2-Bold.ttf\");\n  font-weight: 700;\n}\n@font-face {\n  font-family: Centra;\n  src: url(\"./assets/font/CentraNo2-Medium.ttf\");\n  font-weight: 500;\n}\n@font-face {\n  font-family: Centra;\n  src: url(\"./assets/font/CentraNo2-Book.ttf\");\n  font-weight: 400;\n}\n\n/************ Default Css ************/\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml {\n  scroll-behavior: smooth;\n  scroll-padding-top: 90px;\n  /* verhindert, dass iOS Text beim Drehen automatisch vergroessert */\n  -webkit-text-size-adjust: 100%;\n}\n\nbody {\n  font-weight: 400;\n  overflow-x: hidden;\n  position: relative;\n  background-color: #121212 !important;\n  color: #fff !important;\n  font-family: \"Centra\", sans-serif !important;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin: 0;\n  padding: 0;\n  line-height: normal;\n  overflow-wrap: break-word;\n}\n\np,\na,\nli,\nbutton,\nul {\n  margin: 0;\n  padding: 0;\n  line-height: normal;\n  text-decoration: none;\n  overflow-wrap: break-word;\n}\n\na:hover {\n  text-decoration: none;\n}\n\nimg {\n  width: 100%;\n  max-width: 100%;\n  height: auto;\n}\n\nbutton {\n  border: 0;\n  background-color: transparent;\n}\n\ninput:focus,\ntextarea:focus,\nselect:focus {\n  outline: none;\n}\n\n/* sichtbarer Fokus fuer Tastatur-Navigation */\na:focus-visible,\nbutton:focus-visible {\n  outline: 2px solid #2ae0f0;\n  outline-offset: 3px;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  html {\n    scroll-behavior: auto;\n  }\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n  }\n}\n\n@media (min-width: 1700px) {\n  main .container {\n    max-width: 100%;\n    padding: 0 150px;\n  }\n}\n\np.success {\n  color: green;\n}\n\np.danger {\n  color: red;\n}\n\n/************ Navbar Css ************/\nnav.navbar {\n  padding: 18px 0;\n  position: fixed;\n  width: 100%;\n  top: 0;\n  z-index: 9999;\n  transition: 0.32s ease-in-out;\n}\nnav.navbar.scrolled {\n  padding: 0px 0;\n  background-color: #0e1320;\n}\nnav.navbar a.navbar-brand {\n  width: auto;\n  max-width: 70%;\n  display: flex;\n  align-items: center;\n}\n.navbar-brand-inner {\n  display: inline-flex;\n  align-items: center;\n  min-width: 0;\n}\n.navbar-brand-logo {\n  border-radius: 50%;\n  width: 50px;\n  height: 50px;\n  min-width: 50px;\n  object-fit: cover;\n}\n.navbar-brand-name {\n  margin: 0;\n  padding-left: 20px;\n  color: #fff;\n  font-weight: 500;\n  font-size: 1.4rem;\n  white-space: nowrap;\n}\nnav.navbar .navbar-nav .nav-link.navbar-link {\n  font-weight: 400;\n  color: #fff !important;\n  letter-spacing: 0.8px;\n  padding: 0 25px;\n  font-size: 18px;\n  opacity: 0.75;\n}\nnav.navbar .navbar-nav a.nav-link.navbar-link:hover,\nnav.navbar .navbar-nav a.nav-link.navbar-link.active {\n  opacity: 1;\n}\nspan.navbar-text {\n  display: flex;\n  align-items: center;\n}\n.social-icon {\n  display: inline-flex;\n  margin-left: 14px;\n}\n.social-icon a {\n  width: 42px;\n  height: 42px;\n  min-width: 42px;\n  background: rgba(217, 217, 217, 0.1);\n  display: inline-flex;\n  border-radius: 50%;\n  margin-right: 6px;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  position: relative;\n}\n.social-icon a::before {\n  content: \"\";\n  width: 42px;\n  height: 42px;\n  position: absolute;\n  background-color: #ffffff;\n  border-radius: 50%;\n  transform: scale(0);\n  transition: 0.3s ease-in-out;\n}\n.social-icon a:hover::before {\n  transform: scale(1);\n}\n.social-icon a img {\n  width: 40%;\n  z-index: 1;\n  transition: 0.3s ease-in-out;\n}\n.social-icon a:hover img {\n  filter: brightness(0) saturate(100%) invert(0%) sepia(7%) saturate(98%)\n    hue-rotate(346deg) brightness(95%) contrast(86%);\n}\n.navbar-text button {\n  font-weight: 700;\n  color: #fff;\n  border: 1px solid #fff;\n  padding: 18px 34px;\n  font-size: 18px;\n  margin-left: 18px;\n  position: relative;\n  background-color: transparent;\n  transition: 0.3s ease-in-out;\n}\n.navbar-text button span {\n  z-index: 1;\n}\n.navbar-text button::before {\n  content: \"\";\n  width: 0%;\n  height: 100%;\n  position: absolute;\n  background-color: #fff;\n  left: 0;\n  top: 0;\n  z-index: -1;\n  transition: 0.3s ease-in-out;\n}\n.navbar-text button:hover {\n  color: #121212;\n}\n.navbar-text button:hover::before {\n  content: \"\";\n  width: 100%;\n  height: 100%;\n  position: absolute;\n}\nnav.navbar .navbar-toggler {\n  padding: 8px 10px;\n}\nnav.navbar .navbar-toggler:active,\nnav.navbar .navbar-toggler:focus {\n  outline: none;\n  box-shadow: none;\n}\nnav.navbar .navbar-toggler-icon {\n  width: 24px;\n  height: 17px;\n  background-image: none;\n  position: relative;\n  border-bottom: 2px solid #fff;\n  transition: all 300ms linear;\n  top: -2px;\n}\nnav.navbar .navbar-toggler-icon:focus {\n  border-bottom: 2px solid #fff;\n}\nnav.navbar .navbar-toggler-icon:after,\nnav.navbar .navbar-toggler-icon:before {\n  width: 24px;\n  position: absolute;\n  height: 2px;\n  background-color: #fff;\n  top: 0;\n  left: 0;\n  content: \"\";\n  z-index: 2;\n  transition: all 300ms linear;\n}\nnav.navbar .navbar-toggler-icon:after {\n  top: 8px;\n}\nnav.navbar .navbar-toggler[aria-expanded=\"true\"] .navbar-toggler-icon:after {\n  transform: rotate(45deg);\n  background-color: #fff;\n  height: 2px;\n}\nnav.navbar .navbar-toggler[aria-expanded=\"true\"] .navbar-toggler-icon:before {\n  transform: translateY(8px) rotate(-45deg);\n  background-color: #fff;\n  height: 2px;\n}\nnav.navbar .navbar-toggler[aria-expanded=\"true\"] .navbar-toggler-icon {\n  border-color: transparent;\n}\n\n/* --- Navbar responsive --- */\n@media (max-width: 1199.98px) {\n  nav.navbar .navbar-nav .nav-link.navbar-link {\n    padding: 0 14px;\n    font-size: 17px;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .navbar-brand-name {\n    font-size: 1.15rem;\n  }\n  .navbar-brand-logo {\n    width: 42px;\n    height: 42px;\n    min-width: 42px;\n  }\n}\n\n/* aufgeklapptes Menue braucht einen eigenen Hintergrund,\n   weil die Navbar ueber dem Banner transparent ist\n   (Breakpoint passt zu expand=\"lg\" in der NavBar) */\n@media (max-width: 991.98px) {\n  nav.navbar {\n    padding: 10px 0;\n  }\n  nav.navbar .navbar-collapse {\n    background-color: rgba(14, 19, 32, 0.97);\n    border-radius: 14px;\n    margin-top: 12px;\n    padding: 16px 18px;\n    max-height: calc(100vh - 120px);\n    overflow-y: auto;\n  }\n  nav.navbar .navbar-nav .nav-link.navbar-link {\n    padding: 12px 0;\n    font-size: 18px;\n  }\n  span.navbar-text {\n    justify-content: center;\n    margin-top: 10px;\n  }\n  .social-icon {\n    margin-left: 0;\n  }\n  .navbar-brand-name {\n    padding-left: 12px;\n  }\n}\n\n@media (max-width: 359.98px) {\n  .navbar-brand-name {\n    display: none;\n  }\n}\n\n/************ Banner Css ************/\n.banner {\n  margin-top: 0;\n  padding: clamp(120px, 16vw, 190px) 0 clamp(70px, 12vw, 170px) 0;\n  background-image: url(\"./assets/img/night\\ starry\\ background.png\");\n  background-position: top center;\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n.banner-row {\n  display: flex;\n  align-items: center;\n  margin-left: 0;\n}\n.banner .tagline {\n  font-weight: 700;\n  letter-spacing: 0.8px;\n  padding: 8px 10px;\n  background: linear-gradient(\n    90.21deg,\n    rgba(78, 224, 253, 0.5) -5.91%,\n    rgba(16, 19, 199, 0.5) 111.58%\n  );\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  font-size: clamp(15px, 2.2vw, 20px);\n  margin-bottom: 16px;\n  display: inline-block;\n}\n.banner h1 {\n  font-size: clamp(2.1rem, 6vw, 65px);\n  font-weight: 700;\n  letter-spacing: 0.8px;\n  line-height: 1.05;\n  margin-bottom: 20px;\n  display: block;\n}\n.banner p {\n  color: #b8b8b8;\n  font-size: clamp(16px, 2vw, 20px);\n  letter-spacing: 0.8px;\n  line-height: 1.6em;\n  width: 100%;\n  text-align: justify;\n  hyphens: auto;\n  max-width: 62ch;\n}\n.banner button {\n  color: #fff;\n  font-weight: 700;\n  font-size: 20px;\n  margin-top: 60px;\n  letter-spacing: 0.8px;\n  display: flex;\n  align-items: center;\n}\n.banner button svg {\n  font-size: 25px;\n  margin-left: 10px;\n  transition: 0.3s ease-in-out;\n  line-height: 1;\n}\n.banner button:hover svg {\n  margin-left: 25px;\n}\n.banner-text {\n  margin-top: 40px;\n}\n.banner-image-col {\n  display: flex;\n  justify-content: center;\n  margin-top: 50px;\n}\n.banner-image {\n  border: 4px solid #fff;\n  border-radius: 50%;\n  width: clamp(190px, 40vw, 300px);\n  height: clamp(190px, 40vw, 300px);\n  object-fit: cover;\n  margin-bottom: 30px;\n}\n\n@media (max-width: 767.98px) {\n  .banner {\n    text-align: center;\n  }\n  .banner p {\n    margin: 0 auto;\n  }\n  /* die harten Zeilenumbrueche im Text stoeren auf schmalen Displays */\n  .banner p br {\n    display: none;\n  }\n  .banner-text {\n    margin-top: 0;\n  }\n  .banner-image-col {\n    margin-top: 40px;\n    order: -1;\n  }\n}\n\n@keyframes updown {\n  0% {\n    transform: translateY(-20px);\n  }\n  50% {\n    transform: translateY(20px);\n  }\n  100% {\n    transform: translateY(-20px);\n  }\n}\n.txt-rotate > .wrap {\n  border-right: 0.08em solid #666;\n}\n\n/************ Skills Css ************/\n.skill {\n  padding: 0 0 50px 0;\n  position: relative;\n}\n\n.skill-bx {\n  background: #19233f;\n  border-radius: clamp(24px, 5vw, 64px);\n  text-align: center;\n  padding: clamp(32px, 5vw, 60px) clamp(18px, 4vw, 50px);\n  margin-top: -60px;\n}\n.skill h2 {\n  font-size: clamp(1.9rem, 5vw, 45px);\n  font-weight: 700;\n}\n.skill p {\n  color: #b8b8b8;\n  font-size: clamp(15px, 2vw, 18px);\n  letter-spacing: 0.8px;\n  line-height: 1.5em;\n  margin: 14px auto clamp(35px, 6vw, 75px) auto;\n  max-width: 70ch;\n}\n.skill-slider {\n  width: 80%;\n  margin: 0 auto;\n  position: relative;\n}\n.skill-slider .item {\n  padding: 0 10px;\n}\n.skill-slider .item img {\n  /* einheitliche Icon-Hoehe, damit die Labels auf einer Linie stehen */\n  height: clamp(56px, 9vw, 90px);\n  width: auto;\n  max-width: 100%;\n  object-fit: contain;\n  margin: 0 auto 15px auto;\n  display: block;\n}\n\n.slide-img {\n  height: 50px;\n  width: 50px;\n}\n\n.background-image-left {\n  background-position: center center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  position: absolute;\n  bottom: 0;\n  background-color: #0e1320;\n  height: 100%;\n  z-index: -4;\n}\n\n@media (max-width: 991.98px) {\n  .skill-slider {\n    width: 92%;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .skill-bx {\n    margin-top: -30px;\n  }\n  .skill-slider {\n    width: 100%;\n  }\n  /* harte Umbrueche im Fliesstext deaktivieren */\n  .skill p br {\n    display: none;\n  }\n}\n\n/************ Projects Css ************/\n.project {\n  padding: clamp(60px, 9vw, 100px) 0;\n  position: relative;\n  background-color: #0e1320;\n}\n.project h2 {\n  font-size: clamp(1.9rem, 5vw, 45px);\n  font-weight: 700;\n  text-align: center;\n}\n.project p {\n  color: #b8b8b8;\n  font-size: clamp(15px, 2vw, 18px);\n  letter-spacing: 0.8px;\n  line-height: 1.5em;\n  margin: 14px auto 30px auto;\n  text-align: justify;\n  width: 100%;\n  hyphens: auto;\n  max-width: 70ch;\n}\n.project .nav.nav-pills {\n  width: 100%;\n  max-width: 720px;\n  margin: 0 auto;\n  border-radius: 50px;\n  background-color: rgba(255, 255, 255, 0.1);\n  overflow: hidden;\n}\n.project .nav.nav-pills .nav-item {\n  width: 33.33333%;\n}\n.project .nav.nav-pills .nav-link {\n  background-color: transparent;\n  border-radius: 0;\n  padding: 17px 8px;\n  color: #fff;\n  width: 100%;\n  font-size: clamp(14px, 1.6vw, 17px);\n  letter-spacing: 0.8px;\n  font-weight: 500;\n  position: relative;\n  transition: 0.3s ease-in-out;\n  text-align: center;\n  z-index: 0;\n}\n.project .nav.nav-pills .nav-link::before {\n  content: \"\";\n  position: absolute;\n  width: 0;\n  height: 100%;\n  background: linear-gradient(\n    90.21deg,\n    #2ae0f0 -5.91%,\n    rgba(16, 19, 199, 0.5) 111.58%\n  );\n  top: 0;\n  left: 0;\n  z-index: -1;\n  transition: 0.3s ease-in-out;\n}\n.project .nav.nav-pills .nav-link.active::before {\n  width: 100% !important;\n}\n.project .nav.nav-pills .nav-link.active {\n  border: 1px solid rgba(255, 255, 255, 1);\n}\n.nav-link#projects-tabs-tab-first {\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  border-radius: 55px 0px 0px 55px;\n}\n.nav-link#projects-tabs-tab-second {\n  border-top: 1px solid rgba(255, 255, 255, 0.5);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.5);\n}\n.nav-link#projects-tabs-tab-third {\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  border-radius: 0 55px 55px 0;\n}\n\n/* Tabs untereinander, sobald drei Pills nebeneinander zu eng werden */\n@media (max-width: 575.98px) {\n  .project .nav.nav-pills {\n    flex-direction: column;\n    border-radius: 22px;\n  }\n  .project .nav.nav-pills .nav-item {\n    width: 100%;\n  }\n  .project .nav.nav-pills .nav-link {\n    padding: 14px 8px;\n  }\n  .nav-link#projects-tabs-tab-first {\n    border-radius: 22px 22px 0 0;\n  }\n  .nav-link#projects-tabs-tab-second {\n    border-left: 1px solid rgba(255, 255, 255, 0.5);\n    border-right: 1px solid rgba(255, 255, 255, 0.5);\n  }\n  .nav-link#projects-tabs-tab-third {\n    border-radius: 0 0 22px 22px;\n  }\n}\n\n.projects-grid {\n  max-width: 75%;\n  width: 100%;\n}\n\n@media (max-width: 1199.98px) {\n  .projects-grid {\n    max-width: 90%;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .projects-grid {\n    max-width: 100%;\n  }\n}\n\n.proj-imgbx {\n  position: relative;\n  border-radius: 30px;\n  overflow: hidden;\n  margin-bottom: 24px;\n}\n.proj-imgbx::before {\n  content: \"\";\n  background: linear-gradient(90.21deg, #117087 -5.91%, #09205a 111.58%);\n  opacity: 0.85;\n  position: absolute;\n  width: 100%;\n  height: 0;\n  transition: 0.4s ease-in-out;\n}\n.proj-imgbx:hover::before {\n  height: 100%;\n}\n.proj-txtx {\n  position: absolute;\n  top: 65%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  transition: 0.5s ease-in-out;\n  opacity: 0;\n  width: 100%;\n  padding: 0 14px;\n}\n.proj-imgbx:hover .proj-txtx {\n  top: 50%;\n  opacity: 1;\n}\n.proj-txtx h4,\n.proj-txtx h5 {\n  font-size: clamp(15px, 2.4vw, 18px);\n  font-weight: 700;\n  text-align: center;\n  letter-spacing: 0.8px;\n  line-height: 1.15em;\n  margin-bottom: 6px;\n}\n.proj-txtx span {\n  font-weight: 400;\n  font-size: clamp(12px, 1.4vw, 12px);\n  hyphens: auto;\n  text-align: justify;\n}\n\n/* Tastaturfokus oeffnet das Overlay wie ein Hover */\n.proj-imgbx:focus-within::before {\n  height: 100%;\n}\n.proj-imgbx:focus-within .proj-txtx {\n  top: 50%;\n  opacity: 1;\n}\n\n.proj-caption {\n  display: none;\n}\n\n.proj-tech-text {\n  font-weight: 600 !important;\n  font-style: normal !important;\n  text-align: center !important;\n}\n\n@media (hover: none) {\n  .proj-imgbx::before,\n  .proj-txtx {\n    display: none;\n  }\n  .proj-imgbx {\n    margin-bottom: 14px;\n  }\n  .proj-caption {\n    display: block;\n    margin-bottom: 40px;\n    text-align: left;\n    color: #fff;\n  }\n  .proj-caption h5 {\n    font-size: clamp(17px, 4.2vw, 20px);\n    font-weight: 700;\n    text-align: center;\n    letter-spacing: 0.8px;\n    line-height: 1.25;\n    margin-bottom: 8px;\n  }\n  .proj-caption p {\n    font-size: clamp(14px, 3.6vw, 16px);\n    line-height: 1.55;\n    color: #b8b8b8;\n    margin-bottom: 0 0 8px 0;\n    text-align: justify;\n    hyphens: auto;\n  }\n  .proj-caption .proj-caption-tech {\n    display: block;\n    font-size: 14px;\n    font-weight: 600;\n    letter-spacing: 0.5px;\n    color: #2ae0f0;\n  }\n}\n\n.background-image-right {\n  top: 20%;\n  position: absolute;\n  bottom: 0;\n  width: 35%;\n  right: 0;\n  z-index: -4;\n}\n\n.project-teaser {\n  padding: clamp(14px, 3vw, 20px);\n  border-radius: 6px;\n  background-color: white;\n  color: black;\n}\n\n.project-content {\n  display: flex;\n  align-items: center;\n  gap: 30px;\n  flex-wrap: wrap;\n}\n\n.project-text {\n  flex: 1 1 320px;\n  min-width: min(300px, 100%);\n  text-align: left;\n}\n\n.project-text p,\n.project-text li {\n  font-size: clamp(15px, 1.8vw, 17px);\n}\n\n.project-logo {\n  max-width: 200px;\n  width: 100%;\n  margin-bottom: 10px;\n}\n\n.project-logo-rounded {\n  max-width: 65px;\n  width: 65px;\n  margin-bottom: 10px;\n  border-radius: 50%;\n}\n\n.project-highlights {\n  margin-top: 20px;\n  margin-left: 30px;\n  color: rgba(83, 83, 83, 0.75);\n}\n\n.project-highlights-title {\n  text-align: left !important;\n  margin-bottom: 10px !important;\n  color: #3a3a3a !important;\n  text-decoration: underline;\n}\n\n.project-techstack {\n  border: 2px solid gray;\n  border-radius: 6px;\n  padding: 10px;\n  margin-top: 40px;\n}\n\n.project-image-wrapper {\n  flex: 1 1 320px;\n  min-width: min(300px, 100%);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.project-screenshot {\n  width: 100%;\n  max-width: 400px;\n  height: auto;\n  border-radius: 10px;\n  transition: all 0.3s ease-in-out;\n  box-shadow: 0 4px 15px rgba(22, 22, 22, 0.2);\n}\n\n.image-link {\n  display: block;\n  width: 100%;\n  max-width: 400px;\n}\n\n.github-link {\n  display: inline-block;\n  margin-top: 15px;\n  padding: 10px 20px;\n  background-color: #333;\n  color: #fff;\n  text-decoration: none;\n  border-radius: 5px;\n  font-weight: bold;\n}\n\n.project-button-finecheck {\n  text-align: left;\n  margin-top: 20px;\n}\n\n.github-link:hover {\n  background-color: #555;\n}\n\n@media (max-width: 991.98px) {\n  .project-highlights {\n    margin-left: 18px;\n  }\n}\n\n@media (max-width: 768px) {\n  .project-content {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .project-text,\n  .project-image-wrapper {\n    flex: 1 1 100%;\n    text-align: left;\n  }\n\n  .project-text h2 {\n    text-align: center;\n  }\n\n  .project-button-finecheck {\n    text-align: center;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .project-highlights {\n    margin-left: 6px;\n  }\n  .project-highlights ul {\n    padding-left: 18px;\n  }\n  .project-techstack {\n    margin-top: 24px;\n  }\n}\n\n.image-link:hover .project-screenshot {\n  transform: scale(1.05);\n  transition: all 0.3s ease-in-out;\n}\n\n/************ About Css ************/\n\n.about {\n  background-color: #0e1320;\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n  justify-content: space-around;\n  align-items: center;\n}\n\n.about p {\n  font-size: clamp(1rem, 2.2vw, 1.3rem);\n}\n\n.about h1 {\n  margin-bottom: clamp(28px, 5vw, 50px);\n  font-size: clamp(1.9rem, 5vw, 45px);\n  font-weight: 700;\n  text-align: center;\n}\n\n.about img {\n  width: 100%;\n  max-width: 100%;\n  height: auto;\n  border-radius: 10px;\n}\n\n.about-text {\n  margin-right: 20px;\n}\n\n.about-headline {\n  color: #6faf61;\n  font-size: clamp(1.1rem, 2.6vw, 1.5rem);\n}\n\n.about-headline span {\n  color: #2bbbd4;\n  font-size: clamp(1.5rem, 5vw, 2.8rem);\n}\n\n.about-body {\n  line-height: 1.6;\n  margin-top: 30px;\n  text-align: justify;\n  hyphens: auto;\n  margin-bottom: 50px;\n}\n\n.about-highlight {\n  color: #2bbbd4;\n}\n\n.about-quote {\n  border: 2px solid #fff;\n  padding: 15px 10px 15px 15px;\n  border-radius: 6px;\n  margin-top: 30px;\n}\n\n.about-image-col {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.about-image-frame {\n  border: 4px solid #fff;\n  border-radius: 14px;\n  display: inline-block;\n  width: 80%;\n  overflow: hidden;\n}\n\n@media (max-width: 991.98px) {\n  .about-text {\n    margin-right: 0;\n  }\n  .about-image-col {\n    justify-content: center;\n    margin-top: 30px;\n  }\n  .about-image-frame {\n    width: min(420px, 100%);\n  }\n  .about-body {\n    margin-bottom: 30px;\n  }\n}\n\n.about-me-btn {\n  font-weight: 700;\n  color: black;\n  border: 1px solid #fff;\n  border-radius: 6px;\n  padding: 6px 12px;\n  font-size: 18px;\n  text-decoration: none;\n  background-color: white;\n  position: relative;\n  transition: 0.3s ease-in-out;\n  text-transform: uppercase;\n}\n\n.about-me-btn:hover {\n  color: white;\n  background-color: #2ea3b7;\n  border-color: #2ea3b7;\n}\n\n/************ Timeline Css ************/\n\n.timeline {\n  position: relative;\n}\n\n.timeline-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0 clamp(12px, 4vw, 24px);\n}\n\n.timeline-headline h2 {\n  padding-top: clamp(60px, 9vw, 100px);\n  padding-bottom: clamp(30px, 5vw, 50px);\n  display: block;\n  font-size: clamp(1.9rem, 5vw, 45px);\n  text-align: center;\n}\n\n.background-image {\n  background-position: center center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  position: absolute;\n  bottom: 0;\n  background-color: #0e1320;\n  height: 100%;\n  z-index: -10;\n  opacity: 70%;\n}\n\n.process-wrapper {\n  margin: auto;\n  max-width: 1080px;\n  width: 100%;\n}\n\n/* --- Fortschrittsleiste --- */\n.progress-track {\n  position: relative;\n  width: 100%;\n  margin: 0 auto clamp(40px, 6vw, 70px) auto;\n  padding-top: 20px;\n}\n\n.progress-line {\n  position: absolute;\n  left: 12.5%;\n  right: 12.5%;\n  top: 46px;\n  height: 6px;\n  background: #eee;\n  border-radius: 50px;\n  z-index: 1;\n}\n\n.progress-line-fill {\n  width: var(--progress, 0%);\n  height: 100%;\n  background: #207893;\n  background: linear-gradient(to right, #207893 0%, #2ea3b7 100%);\n  border-radius: 50px;\n  transition: width 0.9s ease;\n}\n\n.progress-steps {\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  z-index: 2;\n}\n\n.progress-step {\n  flex: 1 1 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 26px;\n  text-align: center;\n  padding: 0 8px;\n  color: #fff;\n  background: transparent;\n  border: 0;\n  cursor: pointer;\n  font-size: clamp(13px, 1.4vw, 16px);\n  line-height: 1.3;\n  transition: color 0.3s ease-in-out;\n}\n\n.progress-step:hover,\n.progress-step.active {\n  color: rgba(78, 224, 253, 0.9);\n}\n\n.progress-step-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 52px;\n  width: 52px;\n  transition: transform 0.3s ease-in-out;\n}\n\n.progress-step:hover .progress-step-icon {\n  transform: scale(1.12);\n}\n\n.progress-step-icon img {\n  width: auto;\n  max-width: 46px;\n  max-height: 46px;\n  background-color: white;\n  object-fit: contain;\n}\n\n/* Mobile: Zeitstrahl wird zur vertikalen Liste */\n@media (max-width: 767.98px) {\n  .progress-line {\n    display: none;\n  }\n  .progress-steps {\n    flex-direction: column;\n    gap: 4px;\n    border-left: 3px solid rgba(255, 255, 255, 0.18);\n    padding-left: 4px;\n  }\n  .progress-step {\n    flex-direction: row;\n    align-items: center;\n    gap: 14px;\n    text-align: left;\n    padding: 12px 10px;\n    border-left: 3px solid transparent;\n    margin-left: -5px;\n    font-size: 15px;\n  }\n  .progress-step.active {\n    border-left-color: #2ea3b7;\n    background: rgba(46, 163, 183, 0.12);\n    border-radius: 0 8px 8px 0;\n  }\n  .progress-step-icon {\n    height: 40px;\n    width: 40px;\n    min-width: 40px;\n  }\n  .progress-step-icon img {\n    max-width: 45px !important;\n    max-height: 34px;\n  }\n  .progress-track {\n    padding-top: 0;\n  }\n}\n\n/* --- Inhalte der Zeitstrahl-Abschnitte --- */\n.progress-content-bulletpoint {\n  font-size: 1.7rem;\n  line-height: 1;\n}\n\n#progress-content-section {\n  width: 100%;\n  margin: auto;\n  background: #19233f;\n  border-radius: 8px;\n}\n\n#progress-content-section .section-content {\n  padding: clamp(18px, 4vw, 30px) clamp(14px, 4vw, 40px);\n  text-align: center;\n  animation: FadeInUp 700ms ease 1;\n  animation-fill-mode: forwards;\n  transform: translateY(15px);\n  opacity: 0;\n  margin-bottom: clamp(60px, 10vw, 200px);\n}\n\n#progress-content-section .section-content h2 {\n  font-size: clamp(18px, 2.6vw, 22px);\n  text-transform: uppercase;\n  color: white;\n  text-align: center;\n  letter-spacing: 1px;\n}\n\n#progress-content-section .section-content h5 {\n  text-transform: uppercase;\n  color: white;\n  text-align: center;\n  letter-spacing: 1px;\n  font-size: clamp(15px, 2vw, 20px);\n}\n\n#progress-content-section .section-content p,\n#progress-content-section .section-content span,\n#progress-content-section .section-content li {\n  font-size: clamp(15px, 1.9vw, 20px);\n  line-height: 1.7em;\n  color: white;\n}\n\n.timeline-lead {\n  margin-bottom: 15px;\n}\n\n.timeline-task-box {\n  border: 2px solid rgb(198 222 227 / 64%);\n  padding: clamp(10px, 2.5vw, 16px);\n  background-color: #76becd29;\n  border-radius: 6px;\n  width: min(90%, 100%);\n  margin: 20px auto 0 auto;\n}\n\n.timeline-tasks {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  text-align: left;\n  margin: 0 auto;\n  padding-left: clamp(0px, 3vw, 40px);\n  max-width: 80ch;\n}\n\n.timeline-tasks > span,\n.timeline-tasks > p {\n  color: #fff;\n  margin: 0;\n}\n\n@media (max-width: 575.98px) {\n  .timeline-task-box {\n    width: 100%;\n  }\n  .timeline-tasks {\n    padding-left: 0;\n  }\n  .progress-content-bulletpoint {\n    font-size: 1.2rem;\n  }\n  /* harte Umbrueche in langen Textbloecken deaktivieren */\n  #progress-content-section .section-content br {\n    display: none;\n  }\n}\n\n@keyframes FadeInUp {\n  0% {\n    transform: translateY(15px);\n    opacity: 0;\n  }\n\n  100% {\n    transform: translateY(0px);\n    opacity: 1;\n  }\n}\n\n/************ Contact Css ************/\n.contact {\n  background: linear-gradient(90.21deg, #117087 -5.91%, #161159 111.58%);\n  padding: 60px 0 clamp(80px, 14vw, 200px) 0;\n}\n.contact img {\n  width: 92%;\n}\n.contact h2 {\n  font-size: clamp(1.9rem, 5vw, 45px);\n  font-weight: 700;\n  margin-bottom: 30px;\n}\n.contact form input,\n.contact form textarea {\n  width: 100%;\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  border-radius: 20px;\n  color: #fff;\n  margin: 0 0 8px 0;\n  padding: 18px 26px;\n  font-weight: 500;\n  font-size: 16px;\n  letter-spacing: 0.8px;\n  transition: 0.3s ease-in-out;\n}\n.contact form input:focus,\n.contact form textarea:focus {\n  background: rgba(255, 255, 255, 1);\n  color: #121212;\n}\n.contact form input::placeholder,\n.contact form textarea::placeholder {\n  font-size: 16px;\n  font-weight: 400;\n  color: #fff;\n}\n.contact form input:focus::placeholder,\n.contact form textarea:focus::placeholder {\n  color: #121212;\n  opacity: 0.8;\n}\n.contact form button {\n  font-weight: 700;\n  color: #000;\n  background-color: #fff;\n  padding: 14px 48px;\n  font-size: 18px;\n  margin-top: 25px;\n  border-radius: 0;\n  position: relative;\n  transition: 0.3s ease-in-out;\n}\n.contact form button span {\n  z-index: 1;\n  position: relative;\n}\n.contact form button:hover {\n  color: #fff;\n}\n.contact form button::before {\n  content: \"\";\n  background: #121212;\n  width: 0;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 0;\n  transition: 0.3s ease-in-out;\n}\n.contact form button:hover::before {\n  width: 100%;\n}\n\n/************ Footer Css ************/\n.footer {\n  background-image: url(\"./assets/img/skillsfooter2.png\");\n  background-position: center center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  padding: 30px 0;\n}\n.footer-logo-col {\n  display: flex;\n  align-items: center;\n}\n.footer-logo {\n  border-radius: 50%;\n  width: clamp(100px, 22vw, 150px);\n  height: auto;\n}\n.footer-meta-col {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  justify-content: center;\n}\n.newsletter-bx {\n  background: #ffffff;\n  border-radius: clamp(24px, 5vw, 55px);\n  color: #121212;\n  padding: clamp(35px, 8vw, 85px) clamp(20px, 8vw, 125px);\n  margin-bottom: clamp(40px, 7vw, 80px);\n  margin-top: -122px;\n}\n.newsletter-bx h3 {\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  line-height: 1.2em;\n}\n.new-email-bx {\n  background: #fff;\n  padding: 5px;\n  border-radius: 20px;\n  position: relative;\n  z-index: 0;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n}\n.new-email-bx::before {\n  content: \"\";\n  background: linear-gradient(90.21deg, #40a8c7 -5.91%, #161159 111.58%);\n  border-radius: 20px;\n  position: absolute;\n  z-index: -1;\n  top: -1px;\n  left: -1px;\n  bottom: -1px;\n  right: -1px;\n}\n.new-email-bx::after {\n  content: \"\";\n  background: #fff;\n  border-radius: 20px;\n  position: absolute;\n  z-index: -1;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n.new-email-bx input {\n  width: 100%;\n  color: #121212;\n  font-weight: 500;\n  background: transparent;\n  border: 0;\n  padding: 0 15px;\n}\n.new-email-bx button {\n  background: linear-gradient(90.21deg, #45b7d9 -5.91%, #181167 111.58%);\n  padding: 20px 65px;\n  color: #fff;\n  font-weight: 500;\n  letter-spacing: 0.5px;\n  border-radius: 18px;\n}\n.footer img {\n  width: 26%;\n}\n.footer .footer-logo {\n  width: clamp(100px, 22vw, 150px);\n}\n.footer .social-icon a img {\n  width: 40%;\n}\n.footer p {\n  font-weight: 400;\n  font-size: 14px;\n  color: #b8b8b8;\n  letter-spacing: 0.5px;\n  margin-top: 20px;\n}\n\n@media (max-width: 575.98px) {\n  .footer-logo-col {\n    justify-content: center;\n  }\n  .footer-meta-col {\n    align-items: center;\n    margin-top: 20px;\n  }\n  .footer p {\n    text-align: center;\n  }\n}\n\n.react-multiple-carousel__arrow--right {\n  right: calc(1% + 1px) !important;\n}\n\n.react-multiple-carousel__arrow--left {\n  left: calc(2% + 1px) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
